import React from 'react';
import { Button } from 'antd';
import intl from 'react-intl-universal';

type FallbackElement = React.ReactElement<
  unknown,
  string | React.FC | typeof React.Component
> | null;

export interface FallbackProps {
  error: Error;
}

interface ErrorBoundaryProps {
  fallback?: FallbackElement;
  // onError?: (error: Error, info: string) => void;
}

interface ErrorBoundaryState {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

export default class ErrorBoundary extends React.Component<
  React.PropsWithChildren<ErrorBoundaryProps>,
  ErrorBoundaryState
> {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  // static getDerivedStateFromError(error: Error) {
  //   // Update state so the next render will show the fallback UI.
  //   return { error };
  // }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // if (this.props.onError) {
    //   this.props.onError(error, errorInfo.componentStack);
    // }
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.error && this.state.errorInfo) {
      return (
        <div>
          <h1 style={{ fontFamily: 'Alibaba-PuHuiTi-M', marginBottom: 8 }}>
            {intl.get('layout_error_boundary_load')}
            <Button type="link" onClick={() => window.location.reload()}>
              {intl.get('layout_error_boundary_btn_refresh')}
            </Button>
          </h1>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
